import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";

const styles = {
  contentRoot: {
    p: 3,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
};

export default function BaseInfoModal({
  open = true,
  onClose,
  title,
  children,
  loading = false,
  error = null,
  maxWidth = "xs",
  fullWidth = true,
  showCloseButton = true,
  titleAction = null,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      aria-labelledby="info-modal"
    >
      <DialogTitle id="info-modal">
        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
          <Typography fontSize={20} fontWeight={500} color="text.primary" align="center">
            {title}
          </Typography>
          {titleAction}
        </Box>
        {showCloseButton && (
          <IconButton onClick={onClose} size="large" sx={styles.closeButton}>
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent sx={styles.contentRoot}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" py={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {typeof error === 'string' ? error : 'Failed to load data. Please try again.'}
          </Alert>
        ) : (
          children
        )}
        <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2} mt={4}>
          <Button variant="outlined" color="primary" onClick={onClose}>
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
} 